import { useSelector } from 'react-redux'
import Button from '../atoms/Button'
import css from './AddonBox2.module.scss'
import { useDispatch } from 'react-redux'

import {
	addAddon,
	addItem,
	getItemDetails,
	removeAddon,
	removeAddonChoice,
	updateAddonChoice,
	updateItem,
} from 'src/slices/item'
import InputWrap from '../molecules/InputWrap'
import Checkbox from '../atoms/Checkbox'

export default function AddonBox2({
	addOns,
	index,
	handleTitle,
	handleRemove,
	handleRequired,
	handleLimit,
	handleChoiceName,
	handleChoicePrice,
	handleRemoveChoice,
	handleOption,
}) {
	const dispatch = useDispatch()

	return (
		<div className={css['box']}>
			<div className={css['intro']}>
				<InputWrap
					label='Name'
					component={
						<input
							value={addOns[index]?.title}
							className={css['title']}
							placeholder='e.g. "Extra Cheese"'
							onChange={e => handleTitle(e.target.value, index)}
							defaultValue={addOns[index]}
						/>
					}
				/>

				<InputWrap
					component={
						<input
							// className={css["fuck"]}
							type='number'
							min='0'
							defaultValue={addOns[index]?.limit}
							value={addOns[index]?.limit}
							onChange={e => handleLimit(e.target.value, index)}
						/>
					}
					label='Max Selectable'
				/>

				<Checkbox
					label='Required'
					name={`req + ${index}`}
					// defaultChecked={addOns[index]?.required}
					value={addOns[index]?.required}
					onChange={e => {
						handleRequired(e.target.checked, index)
					}}
				/>
			</div>

			{addOns[index]?.options?.map((option, i) => {
				return (
					<div className={css['option']}>
						<InputWrap
							component={
								<input
									placeholder='e.g "Cheddar"'
									value={addOns[index]?.options?.[i].name}
									defaultValue={option.name}
									onChange={e => handleChoiceName(e.target.value, i)}
								/>
							}
							label='Option'
						/>
						<InputWrap
							component={
								<input
									type='number'
									value={addOns[index]?.options?.[i].price}
									defaultValue={option.price}
									onChange={e => handleChoicePrice(e.target.value, i)}
								/>
							}
							label='Price ($)'
						/>
						<Button
							iconLeft='fad fa-times'
							color='gray'
							variant='secondary'
							style={{ width: '16px', height: '16px' }}
							action={() => handleRemoveChoice(i)}
						/>
					</div>
				)
			})}

			<div className={css['buttons']}>
				<Button
					iconLeft='fad fa-trash-alt'
					// action={() => alert("deleted")}
					color='red'
					label='Remove Add-on'
					variant='tertiary'
					action={() => handleRemove(index)}
					size='s'
				/>

				<Button
					label='Add Option'
					// style={{ height: "32px", margin: "8px 8px" }}
					color='blue'
					variant='secondary'
					iconLeft='fad fa-plus'
					size='s'
					action={() => handleOption(index)}
				/>
			</div>
		</div>
	)
}
